
    <ol class="breadcrumb">
      <li *ngFor="let breadcrumb of breadcrumbs">
      <a *ngIf="breadcrumb.disabled; else enabledTemplate">{{ ('breadcrumb.' + breadcrumb.label) | translate }}</a>
      <ng-template #enabledTemplate>
        <a *ngIf="!(breadcrumb.isTerminal)" [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ ('breadcrumb.' + breadcrumb.label) | translate }}</a>
        <a *ngIf="(breadcrumb.isTerminal)" style="color: #ffa500;" [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ ('breadcrumb.' + breadcrumb.label) | translate}}</a>
      </ng-template>
        </li>
      <div *ngIf="storeName"  class="ribbon-content">
        <div class="ribbon base-alt"> <span>{{ storeName }}</span></div>
      </div>
    </ol>
   
  


// WEBPACK FOOTER //
// ./src/app/common/components/app-breadcrumb.component.ts.AppBreadcrumbComponent.html